import React, { useEffect, useMemo } from 'react';

import { DocumentsSections } from '@cd3p/core/modules/documents';
import { APIUserType } from '@cd3p/core/types/api';
import { GlobalLoader } from 'components';

import { RouterOutlet, styled, useSelector } from 'third-party';

import { useTermsAndConditions } from 'modules/termsAndConditions';

import { appSelectors, termsAndConditionsSelectors } from 'selectors';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  flex: 1 1 0;
  margin: 1rem auto;
  padding: 3rem;
  overflow-y: auto;
`;

export const OnBoardingStep2TermsAndConditions = () => {
  const userType = useSelector(appSelectors.userType);

  const documentsSection = useMemo(() => {
    return userType === APIUserType.Contractor
      ? DocumentsSections.TermsAndConditionsWebContractor
      : DocumentsSections.TermsAndConditionsWebDispatcher;
  }, [userType]);

  const { loadTermsAndConditionsDocuments } =
    useTermsAndConditions(documentsSection);

  useEffect(() => {
    loadTermsAndConditionsDocuments();
  }, [loadTermsAndConditionsDocuments]);

  const termsAndConditionsItemsLoaded = useSelector(
    termsAndConditionsSelectors.termsAndConditionsItemsLoaded,
  );

  return !termsAndConditionsItemsLoaded ? (
    <GlobalLoader />
  ) : (
    <Wrapper>
      <RouterOutlet />
    </Wrapper>
  );
};
